import { Dialog } from '@radix-ui/react-dialog'
import { InfoIcon } from 'lucide-react'

import { TermsOfService } from '@/features/compliance/components/TermsOfService'
import { Button } from '@/ui/atoms/button/Button'
import { DialogContent, DialogTrigger } from '@/ui/atoms/dialog/Dialog'

export interface ToSNotAcceptedViewProps {
  onAccept: () => void
}

export function ToSNotAcceptedView({ onAccept }: ToSNotAcceptedViewProps) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-1 md:gap-0.5">
        <InfoIcon className="icon-size-xs icon-tertiary" />
        <div className="typography-body-4 text-secondary">You have to accept the Terms of Service to continue.</div>
      </div>
      <Dialog>
        <DialogTrigger asChild>
          <Button>Accept Terms of Service</Button>
        </DialogTrigger>
        <DialogContent preventAutoFocus>
          <TermsOfService onAgree={onAccept} />
        </DialogContent>
      </Dialog>
    </div>
  )
}
